"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilteredExtensions = exports.getFilterType = exports.getFilter = void 0;

var getFilter = function getFilter(state) {
  return state.filter;
};

exports.getFilter = getFilter;

var getFilterType = function getFilterType(state) {
  return state.filter.get('filterType');
};

exports.getFilterType = getFilterType;

var getFilteredExtensions = function getFilteredExtensions(state) {
  return state.filter.get('extensions');
};

exports.getFilteredExtensions = getFilteredExtensions;